import React from 'react';
import { cn } from '@/utils/cn';

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => {
  return (
    <textarea
      {...props}
      ref={ref}
      className={cn(
        'w-full min-h-[100px] rounded-[8px] border border-[#D9D9D9] p-[8px] resize-none overflow-hidden text-[13px] transition-all duration-100',
        className
      )}
    />
  );
});

Textarea.displayName = 'Textarea';
export default Textarea;
